import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export function MemberRoute({ children }) {
  const { isMember, loading } = useAuth();
  const location = useLocation();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <span className="overline">Loading…</span>
      </div>
    );
  if (!isMember) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

export function AdminRoute({ children }) {
  const { isAdmin, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <span className="overline">Caricamento…</span>
      </div>
    );
  if (!isAdmin) return <Navigate to="/vault-9821" replace />;
  return children;
}
